import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const paymentTypeModURL = "api/v1/customer-master-app/payment-type";
//obtaining the paginated data
export const getPaymentType = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${paymentTypeModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllPaymentType = () => axiosInstance.get(`${paymentTypeModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPagePaymentType = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${paymentTypeModURL}/list?offset=${(number - 1) * rowsPerPage}&limit=${rowsPerPage}&ordering=-id`);

//creating function
export const createPaymentType = (body) => axiosInstance.post(`${paymentTypeModURL}/create`, body);
//updating function
export const updatePaymentType = (id, body) => axiosInstance.patch(`${paymentTypeModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) =>
  axiosInstance.get(`${paymentTypeModURL}/list?ordering=${sortOrder}&offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataPaymentTypeName = (e, cancelToken) =>
  axiosInstance.get(`${paymentTypeModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
